
import AP from '../config/api.config'
import { PLACEHOLDER_DATA_URI } from '@/assets/placeholder'
import BarcodeDisplay from '@/components/common/BarcodeDisplay.vue'
import { sampleBySeed, buildStrongHead, stockFirst } from '@/unit/recommend'
import { resolveProductImageUrls, resolveProductImageUrl } from '@/utils/image'
import { fetchCustomerService } from '@/utils/customerService'
import { fetchPublicConfig, getPublicConfig, resolveShopShortName } from '@/utils/publicConfig'
import { getCategoryName } from '@/utils/category-dictionary'
import { specResultQuery } from '@/utils/searchEntries'

// 枚举类规格白名单：key 对齐 product_tags spec_* 字典（值进过字典=可枚举=可点击筛选）
// 描述文本（specification 自由文本）/编码（inner_code、barcode）不在列，不做链接
const SPEC_LINK_FIELDS = {
  width: '宽度', size: '尺寸', grade: '等级', voltage: '电压',
  batt_type: '电池类型', batt_model: '电池型号',
  vehicle_model: '车型', tire_type: '轮胎类型', ply: '层级', tool_size: '工具尺寸',
  chain_pitch: '链条节距', chain_links: '链条节数', sprocket_pitch: '链轮节距', sprocket_teeth: '链轮齿数',
  bearing_id: '轴承内径', bearing_od: '轴承外径', bearing_width: '轴承宽度', bearing_type: '轴承类型', bearing_model: '轴承型号',
  seal_id: '油封内径', seal_od: '油封外径', seal_thickness: '油封厚度',
  brake_model: '刹车片型号', spark_thread: '火花塞螺纹', spark_length: '火花塞长度',
  bulb_power: '灯泡功率', bulb_voltage: '灯泡电压'
}

export default {
  name: 'Detailspage',
  components: { BarcodeDisplay },
  data () {
    return {
      isDisplay: false,
      showTierBadge: true, // "惠/靓/正"角标全局开关（public config 下发；默认显示）
      isScrolling: false,
      actionBarHidden: false, // 滑过"更多推荐"后收起底部操作栏（渐隐+下推出），滚回复原
      _scrollTimer: null,
      _lastScrollTop: 0,
      Count: 1,
      slide: 0,
      loading: true,
      adding: false,
      showSuccess: false,
      isFavorited: false,
      liked: false,
      likeCount: 0,
      loadingMore: false,
      moreLimit: 22,
      BATCH_SIZE: 6, // 相关推荐瀑布流每批追加量（首轮首批同此，触底 +N）
      moreProductPool: [], // related 缓存池（后端一次返回，前端 sampleBySeed 循环）
      promotionBanner: null,
      selectedUnitName: '',
      unitMenuOpen: false,
      userDifficultyRating: 0,
      ratedToday: false, // 今日已反馈该商品（每日一次；历史评分不禁用次日再评）
      ratingSubmitting: false,
      showStockDialog: false,
      stockSaving: false,
      stockForm: { newStock: 0, note: '' },
      product: {
        id: '',
        name: '',
        description: '',
        image: '',
        stock: 0,
        brand: '',
        unit: '个',
        pack_unit: '',
        pack_quantity: 1
      },
      moreProducts: [],
      defaultImage: PLACEHOLDER_DATA_URI,
      touchStartX: 0,
      touchStartY: 0,
      touchStartTime: 0,
      handleTouchStart: null,
      handleTouchMove: null,
      handleTouchEnd: null,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      btnX: 0,
      btnY: 0,
      hasMoved: false,
      isDraggingHome: false,
      dragStartXHome: 0,
      dragStartYHome: 0,
      btnXHome: 0,
      btnYHome: 0,
      hasMovedHome: false,
      showImagePreview: false,
      previewImages: [],
      previewIndex: 0,
      // 客服电话（canonical 配置；未配置时隐藏客服按钮，不渲染空 tel: 链接）
      servicePhone: ''
    }
  },
  mounted () {
    // 初始化两个按钮位置（使用 left/top 定位，确保 getBoundingClientRect() 准确）
    const backBtn = this.$refs.backBtn
    if (backBtn) {
      backBtn.style.left = '10px'
      backBtn.style.top = '10px'
      backBtn.style.right = 'auto'
      backBtn.style.bottom = 'auto'
    }
    const homeBtn = this.$refs.homeBtn
    if (homeBtn) {
      // 返回主页按钮在返回上一页按钮下方，间隔 8px
      // top = 10px (backBtn top) + 44px (btn height) + 8px (gap)
      homeBtn.style.left = '10px'
      homeBtn.style.top = '62px'
      homeBtn.style.right = 'auto'
      homeBtn.style.bottom = 'auto'
    }
    // 提前续页：sentinel 进入"距底部约 1.2 视口"预载区即追加下一批（本地池循环，不发请求）。
    // rootMargin bottom 120% = 视口下沿再扩 1.2×vh，sentinel 尚未真正入屏就触发，用户感知不到页面底部。
    this._sentinelObserver = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) this.ensurePrefill()
    }, { root: null, rootMargin: '0px 0px 120% 0px', threshold: 0 })
    this.$nextTick(() => {
      const el = this.$refs.infiniteSentinel
      if (el) this._sentinelObserver.observe(el)
    })
  },
  beforeDestroy () {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.endDrag)
    document.removeEventListener('touchmove', this.onDrag)
    document.removeEventListener('touchend', this.endDrag)
    // 确保离开页面时关闭图片预览
    this.showImagePreview = false
    this.previewImages = []
    this.previewIndex = 0
  },
  created () {
    this.product.id = this.$route.query.id
    document.title = '商品详情'
    document.body.scrollTop = document.documentElement.scrollTop = 0
    window.addEventListener('scroll', this.getScroll)
    this.initSwipeBack()
    this.fetchProduct()
    this.fetchMoreProducts()
    this.checkFavorite()
    fetchCustomerService().then(cs => { this.servicePhone = cs.phone })
    // "惠/靓/正"角标全局开关（默认 true，显式 false 才隐藏）
    fetchPublicConfig().then(cfg => { this.showTierBadge = cfg.showHuiliangzhengBadge !== false })
    this.fetchLikeStatus()
    this.fetchRepairDifficulty()
  },
  watch: {
    '$route.query.id' (newId) {
      if (newId && newId !== this.product.id) {
        this.product.id = newId
        this.Count = 1
        this.moreProducts = []
        this.moreProductPool = []
        this.isFavorited = false
        // 个人交互状态随商品切换：残留上一商品的值会禁用/错显当前商品的评价与点赞
        this.liked = false
        this.ratedToday = false
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.fetchProduct()
        this.fetchMoreProducts()
        this.checkFavorite()
        this.fetchLikeStatus()
        this.fetchRepairDifficulty()
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.getScroll)
    this.removeSwipeBack()
    if (this._sentinelObserver) this._sentinelObserver.disconnect()
  },
  computed: {
    // 分类 Tag 展示名（字典唯一真理源；无分类/未收录 key 降级不渲染——见模板 v-if）
    categoryDisplayName () {
      return this.product.category ? getCategoryName(this.product.category) : ''
    },
    // 瀑布流双列：moreProducts 偶数入左列，奇数入右列（移动端 column-count 列平衡不可控）
    leftMoreProducts () {
      return this.moreProducts.filter((_, i) => i % 2 === 0)
    },
    rightMoreProducts () {
      return this.moreProducts.filter((_, i) => i % 2 === 1)
    },
    // 用户角色 - 使用 store getter
    userRole () {
      return this.$store.getters.userRole
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    },
    isCourier () {
      return this.$store.getters.isCourier
    },
    isOperator () {
      return this.$store.getters.isOperator
    },
    // 业务员只读：无价格/购买/购物车/优惠券（后端 operator DTO 已剥金额，这里同步隐藏购买入口）
    isReadOnly () {
      return this.isOperator || this.isCourier
    },
    productImages () {
      // 统一归一（utils/image）：正式排序全量 URL 数组，[0] 即主图（image ≡ images[0]；
      // images 空/无效 fallback [image] 存量单图形态）——页面不再自行 JSON.parse
      return resolveProductImageUrls(this.product)
    },
    // 是否有真实主图
    hasRealMainImages () {
      return this.productImages.length > 0
    },
    // 单位列表（product.units 优先，空则从旧字段构造；单单位仅 1 项 → 不显示下拉）
    unitList () {
      const p = this.product
      if (Array.isArray(p.units) && p.units.length) {
        return p.units.map(u => ({ unit_name: u.unit_name || u.name, ratio: Number(u.is_base ? 1 : (u.ratio != null ? u.ratio : u.ratio_to_base)), is_base: u.is_base ? 1 : 0 }))
      }
      const list = [{ unit_name: p.unit || '个', ratio: 1, is_base: 1 }]
      if (p.pack_unit && Number(p.pack_quantity) > 1) list.push({ unit_name: p.pack_unit, ratio: Number(p.pack_quantity), is_base: 0 })
      return list
    },
    baseUnitName () {
      const b = this.unitList.find(u => u.is_base)
      return b ? b.unit_name : (this.product.unit || '个')
    },
    // 包装换算摘要（详情页规格区）：单一数据源 unitList，展示完整多单位层级；
    // 单单位返回空 → 不显示"包装"行。卡片不展示辅助单位，仅此处展示。
    packSummary () {
      const base = this.baseUnitName
      return this.unitList
        .filter(u => !u.is_base && Number(u.ratio) > 1)
        .map(u => `1${u.unit_name}=${u.ratio}${base}`)
        .join(' · ')
    },
    // 当前选中单位（selectedUnitName 未初始化时回退基础单位）
    currentUnit () {
      return this.unitList.find(u => u.unit_name === this.selectedUnitName) || this.unitList.find(u => u.is_base) || this.unitList[0] || { unit_name: '个', ratio: 1, is_base: 1 }
    },
    currentRatio () { return Number(this.currentUnit.ratio) || 1 },
    // 兼容旧字段：基础单位='unit'，包装单位='pack'（cart.unit_type 仅作标记，不参与计量）
    selectedUnitType () { return this.currentUnit.is_base ? 'unit' : 'pack' },
    // 最大可购买数量（按所选单位 ratio 折算：stock / ratio 向下取整）
    maxQuantity () {
      const r = this.currentRatio
      return r > 1 ? Math.floor(Number(this.product.stock) / r) : Number(this.product.stock)
    },
    // 实际商品数量（基础单位数 = Count × ratio；下单/库存/价格都以此为准）
    actualQuantity () { return this.Count * this.currentRatio },
    // 维修难度文字标签
    difficultyText () {
      const rating = this.displayDifficulty
      const texts = ['', '很简单', '简单', '一般', '较难', '困难']
      return texts[Math.round(rating)] || '未评分'
    },
    // 维修难度提示文字
    difficultyHint () {
      const hints = [
        '',
        '更换简单，动手能力强的人可自己完成',
        '有一定难度，建议有维修经验的人操作',
        '难度适中，需要专业工具和一定技能',
        '较复杂，需要专业技能或专业维修人员',
        '非常困难，强烈建议由专业维修人员处理'
      ]
      const rating = Math.round(this.displayDifficulty)
      return hints[rating] || ''
    },
    // 显示的维修难度星级（后端贝叶斯评分，1 位小数）
    displayDifficulty () {
      return this.product.display_repair_difficulty || this.product.repair_difficulty || 3
    },
    // 商品详情图：展示全部 images（不剔除第一张）
    detailImages () {
      return this.productImages.length > 1 ? this.productImages : []
    },
    // 主图除第一张外的其他图（保留兼容）
    otherImages () {
      return []
    },
    // 是否有规格参数
    hasSpecs () {
      const p = this.product
      return p.brand || p.model || p.specification || p.category || p.unit || (p.pack_unit && p.pack_quantity) || this.applicableModels.length || this.specEntries.length
    },
    // 枚举类规格参数（product_specs JSON → 白名单字段 → 可点击跳规格筛选）
    // 白名单 = 值进过 product_tags spec_* 字典的枚举字段；描述文本/编码不在列，无链接
    specEntries () {
      let v = this.product.product_specs
      if (!v) return []
      if (typeof v === 'string') {
        try { v = JSON.parse(v) } catch (e) { return [] }
      }
      if (!v || typeof v !== 'object') return []
      return Object.keys(v)
        .filter(k => SPEC_LINK_FIELDS[k] && v[k] !== null && v[k] !== undefined && String(v[k]).trim() !== '')
        .map(k => ({ key: k, label: SPEC_LINK_FIELDS[k], value: String(v[k]).trim() }))
    },
    // 适用车型（applicable_models：JSON 数组字符串或数组，兼容解析；空/无效 → [] 不显示该行）
    applicableModels () {
      const raw = this.product.applicable_models
      if (!raw) return []
      let v = raw
      if (typeof raw === 'string') {
        try { v = JSON.parse(raw) } catch (e) { return [] }
      }
      if (!Array.isArray(v)) return []
      return v.map(m => (m || '').trim()).filter(Boolean)
    },
    // 是否有任何真实图片（主图或详情图）
    hasAnyRealImage () {
      // 检查详情图（过滤无效值）
      const validDetailImages = this.detailImages.filter(img =>
        img && img !== 'null' && img !== 'undefined' && img !== '' && img !== null && img !== undefined
      )
      if (validDetailImages.length > 0) return true

      // 检查主图（排除默认占位图和无效值）
      const realMainImages = this.productImages.filter(img =>
        img &&
        img !== this.defaultImage &&
        img !== 'null' &&
        img !== 'undefined' &&
        img !== '' &&
        img !== null &&
        img !== undefined
      )
      return realMainImages.length > 0
    }
  },
  methods: {
    // 图片预览相关方法
    previewMainImages (index) {
      this.previewImages = this.productImages.map(img => this.$img(img, 'original')).filter(url => url)
      this.previewIndex = index
      this.showImagePreview = true
    },
    previewDetailImages (index) {
      this.previewImages = this.detailImages.map(img => this.$img(img, 'original')).filter(url => url)
      this.previewIndex = index
      this.showImagePreview = true
    },
    previewOtherImages (index) {
      this.previewImages = this.otherImages.map(img => this.$img(img, 'original')).filter(url => url)
      this.previewIndex = index
      this.showImagePreview = true
    },
    // 图片预览关闭处理
    handlePreviewClose () {
      // 确保状态正确关闭
      this.showImagePreview = false
      this.previewImages = []
      this.previewIndex = 0
    },
    // 管理员编辑商品
    editProduct () {
      this.$router.push(`/product/${this.product.id}/edit`)
    },
    // 获取商品缩略图（统一 utils/image 归一：正式排序 [0]，不再页面自 parse）
    getProductThumb (product) {
      const url = resolveProductImageUrl(product)
      return (url && this.$img(url)) || this.defaultImage
    },
    async fetchProduct () {
      // 过期保护：请求前快照路由 id，返回时路由已切到别的商品 → 丢弃（慢返回的 A 不许覆盖 B）
      const rid = this.$route.query.id
      this.userDifficultyRating = 0
      this.loading = true
      try {
        // 业务员走只读 DTO（后端递归剥除全部金额字段），不直调公开 /products/:id
        const url = this.isOperator
          ? `/operator-mobile/products/${this.product.id}`
          : `${AP.apiList.getProductDetail}/${this.product.id}`
        const res = await this.axios({ url, method: 'get' })
        if (rid !== this.$route.query.id) return
        if (res.data.code === 200) {
          this.product = res.data.data
          // 标题 = 商品名-店铺短名（与全站内页"页面名-店铺名"同规则）；店铺未配置=纯商品名
          const cached = getPublicConfig()
          const applyDetailTitle = (cfg) => {
            const shop = resolveShopShortName(cfg)
            document.title = shop ? `${this.product.name}-${shop}` : this.product.name
          }
          if (cached) applyDetailTitle(cached)
          else fetchPublicConfig().then(applyDetailTitle).catch(() => {})
          // 获取商品关联的促销活动
          this.fetchPromotionBanner()
          // 获取用户对该商品的评分
          this.fetchUserRating()
        } else {
          alert('商品不存在')
          this.$router.back()
        }
      } catch (err) {
        console.error('获取商品失败:', err)
        alert('获取商品信息失败')
      } finally {
        this.loading = false
      }
    },
    async fetchUserRating () {
      const userId = localStorage.getItem('userId')
      if (!userId) return
      const rid = this.$route.query.id
      try {
        const res = await this.axios.get(`/products/${this.product.id}/my-rating`)
        if (rid !== this.$route.query.id) return
        if (res.data.code === 200 && res.data.data.rating > 0) {
          this.userDifficultyRating = res.data.data.rating
        }
      } catch (e) {}
    },
    async fetchPromotionBanner () {
      // 先重置，避免显示上一个商品的促销
      this.promotionBanner = null
      const rid = this.$route.query.id
      try {
        const res = await this.axios.get(`product/${this.product.id}/promotion`)
        if (rid !== this.$route.query.id) return
        if (res.data.code === 200 && res.data.data) {
          this.promotionBanner = res.data.data
        }
      } catch (e) {}
    },
    handlePromotionClick () {
      if (this.promotionBanner?.banner_url) {
        if (this.promotionBanner.banner_url.startsWith('http')) {
          window.open(this.promotionBanner.banner_url, '_blank')
        } else {
          this.$router.push(this.promotionBanner.banner_url)
        }
      }
    },
    // 用户打分维修难度
    async setDifficultyRating (rating) {
      const token = localStorage.getItem('token')
      if (!token) {
        this.$q.notify && this.$q.notify({ type: 'warning', message: '请先登录后再评分' })
        return
      }
      // 今日已反馈 → 防止重复提交（历史评分不禁用次日再评）
      if (this.ratedToday) return

      this.ratingSubmitting = true
      try {
        const res = await this.axios.post(`/products/${this.product.id}/rate`, { rating })
        if (res.data.code === 200) {
          this.userDifficultyRating = rating
          await this.fetchRepairDifficulty()
          this.$q.notify && this.$q.notify({ type: 'positive', message: '评价成功' })
        } else {
          this.$q.notify && this.$q.notify({ type: 'negative', message: res.data.message || '评价失败' })
        }
      } catch (err) {
        console.error('评分提交失败:', err)
        this.$q.notify && this.$q.notify({ type: 'negative', message: err.response?.data?.message || '评分提交失败，请稍后重试' })
      } finally {
        this.ratingSubmitting = false
      }
    },
    // 轻量获取维修难度数据（评分提交后局部刷新，不触发整页重载）
    async fetchRepairDifficulty () {
      const rid = this.$route.query.id
      try {
        const res = await this.axios.get(`/products/${this.product.id}/difficulty`)
        if (rid !== this.$route.query.id) return
        if (res.data.code === 200) {
          const d = res.data.data
          this.product.display_repair_difficulty = d.display_repair_difficulty
          this.product.repair_difficulty = d.repair_difficulty
          this.product.user_rating_sum = d.user_rating_sum
          this.product.user_rating_count = d.user_rating_count
          this.product.admin_override_rating = d.admin_override_rating
          this.product.admin_override_enabled = d.admin_override_enabled
          // 附带当前用户评分 + 今日是否已反馈（每日一次的禁用依据）
          if (d.user_rating > 0) this.userDifficultyRating = d.user_rating
          this.ratedToday = !!d.rated_today
        }
      } catch (err) {
        console.error('获取维修难度失败:', err)
      }
    },
    formatDate (dateStr) {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' })
    },
    async addToCart () {
      if (this.adding) return

      const token = localStorage.getItem('token')
      if (!token) {
        alert('请先登录')
        this.$router.push('/')
        return
      }

      if (this.actualQuantity > this.product.stock) {
        alert('库存不足')
        return
      }

      this.adding = true
      try {
        const payload = {
          product_id: this.product.id,
          quantity: this.actualQuantity,
          display_quantity: this.Count,
          unit_type: this.selectedUnitType,
          unit_name: this.currentUnit.unit_name,
          unit_ratio: this.currentRatio
        }
        console.log('加入货篮请求数据:', payload)

        const res = await this.axios({
          url: AP.apiList.addToCart,
          method: 'post',
          headers: { Authorization: `Bearer ${token}` },
          data: payload
        })

        if (res && res.data && res.data.code === 200) {
          this.showToast('已加入货篮')
          this.Count = 1
          this.$store.dispatch('refreshCartCount')
        } else {
          const msg = res && res.data ? res.data.message : '网络错误'
          console.error('加入货篮返回错误:', res)
          this.showToast(msg || '加入失败', 'error')
        }
      } catch (err) {
        console.error('加入货篮请求异常:', err)
        if (err.message && err.message.includes('cancel')) {
          return
        }
        this.showToast('加入货篮失败，请稍后重试', 'error')
      } finally {
        this.adding = false
      }
    },
    // 去货篮结算 - 直接带入当前商品
    async goCartWithCurrentItem () {
      if (this.adding) return

      const token = localStorage.getItem('token')
      if (!token) {
        alert('请先登录')
        this.$router.push('/')
        return
      }

      // 校验库存
      if (this.actualQuantity > this.product.stock) {
        alert('库存不足')
        return
      }

      this.adding = true
      try {
        // 1. 先查询货篮状态
        const cartRes = await this.axios({
          url: AP.apiList.getCart,
          method: 'get',
          headers: { Authorization: `Bearer ${token}` }
        })
        const cartItems = cartRes.data.code === 200 ? cartRes.data.data : []
        const isCartEmpty = cartItems.length === 0

        // 情况1：货篮已有该商品（同商品同规格）且详情页数量为 1 → 直接去货篮，不再重复加
        const existing = cartItems.find(item =>
          item.product_id === this.product.id && item.unit_name === this.currentUnit.unit_name
        )
        if (existing && this.actualQuantity === 1) {
          this.$router.push('/cart')
          return
        }
        // 情况2（已有且数量>1：货篮数量 += 详情页数量）/ 情况3（货篮没有）→ 维持原加入逻辑

        // 2. 将当前商品加入货篮
        const payload = {
          product_id: this.product.id,
          quantity: this.actualQuantity,
          display_quantity: this.Count,
          unit_type: this.selectedUnitType,
          unit_name: this.currentUnit.unit_name,
          unit_ratio: this.currentRatio
        }

        const res = await this.axios({
          url: AP.apiList.addToCart,
          method: 'post',
          headers: { Authorization: `Bearer ${token}` },
          data: payload
        })

        if (res && res.data && res.data.code === 200) {
          // 3. 获取新加入商品的 cart_id
          const newCartId = res.data.data?.id || res.data.data?.cart_id
          this.$store.dispatch('refreshCartCount')

          if (isCartEmpty && newCartId) {
            // 货篮为空：带上 checkout=1 和 select 参数，让货篮页自动打开结算并选中该商品
            this.$router.push(`/cart?checkout=1&select=${newCartId}`)
          } else {
            // 货篮不为空：正常跳转到货篮页
            this.$router.push('/cart')
          }
        } else {
          const msg = res && res.data ? res.data.message : '网络错误'
          this.showToast(msg || '加入失败', 'error')
        }
      } catch (err) {
        console.error('加入货篮请求异常:', err)
        this.showToast('加入货篮失败，请稍后重试', 'error')
      } finally {
        this.adding = false
      }
    },
    showToast (message, type = 'success') {
      try {
        if (this.$q && this.$q.notify) {
          this.$q.notify({
            message: message,
            color: type === 'success' ? '#FF6F36' : 'negative',
            position: 'top',
            timeout: 1500,
            actions: [{ icon: 'close', color: 'white' }]
          })
          return
        }
      } catch (e) {
        console.error('Quasar notify failed:', e)
      }

      const toast = document.createElement('div')
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: fit-content;
        background: ${type === 'success' ? '#FF6F36' : '#c10015'};
        color: white;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 14px;
        z-index: 9999;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        animation: slideDown 0.3s ease;
      `
      toast.textContent = message
      document.body.appendChild(toast)

      setTimeout(() => {
        toast.style.animation = 'slideUp 0.3s ease'
        setTimeout(() => toast.remove(), 300)
      }, 1500)
    },
    getScroll () {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop >= 320
      ) {
        this.isDisplay = true
      } else {
        this.isDisplay = false
      }
      // 方向判定带最小位移阈值：触底后滚动被钳制，继续下 flick 的 scroll 事件 Δ=0，
      // 会被误判成"向上浏览"触发复原闪一下。Δ≈0（触底钳制/惯性归零）→ 保持现状不动。
      const dy = this.scrollTop - this._lastScrollTop
      const scrollingDown = dy > 2
      const scrollingUp = dy < -2
      // 向下滚动超过200px → 按钮缩小+消失；向上滚动 → 复原；Δ≈0（触底钳制）→ 保持现状防闪
      if (scrollingDown) this.isScrolling = this.scrollTop > 200
      else if (scrollingUp) this.isScrolling = false

      // 底部操作栏收起/复原——与 isScrolling 同款纯方向触发（back-fixed/home-fixed 的机制）：
      //   复原 = 真实向上浏览（不依赖标题位置，禁止状态机分支，否则惯性滚动逐事件振荡）；
      //   收起 = 向下滚动 且 "更多推荐"标题已完全滑出视口顶（唯一检测标题的时机）。
      if (scrollingUp) {
        this.actionBarHidden = false
      } else if (scrollingDown) {
        const moreTitle = this.$refs.moreRecoTitle
        if (moreTitle && moreTitle.getBoundingClientRect().bottom <= 0) this.actionBarHidden = true
      }

      this._lastScrollTop = this.scrollTop
      // 瀑布流续页：IO 为主触发（见 mounted），scroll 事件同口径兜底（快速 fling 下更实时）
      this.ensurePrefill()
    },
    goBackTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.isDisplay = false
    },
    toBack () {
      // 如果有历史记录则返回，否则跳转到首页
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/home')
      }
    },
    onBackClick () {
      if (this.hasMoved) return
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/home')
      }
    },
    goHome () {
      if (this.hasMovedHome) return
      this.$router.push('/home')
    },
    startDragHome (e) {
      // 仅 mouse：阻止原生 drag 会话启动（否则指针滑过商品图 <img> 时 dragover 会吞掉后续 mousemove，拖拽卡在第一步）。
      // touchstart 上 preventDefault 会吞掉合成 click（手机上按钮点不动）；touch 滚动由 CSS touch-action:none 兜底
      if (e.type === 'mousedown' && e.preventDefault) e.preventDefault()
      this.isDraggingHome = true
      this.hasMovedHome = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartXHome = touch.clientX
      this.dragStartYHome = touch.clientY
      const btn = this.$refs.homeBtn
      const rect = btn.getBoundingClientRect()
      this.btnXHome = rect.left
      this.btnYHome = rect.top
      document.addEventListener('mousemove', this.onDragHome)
      document.addEventListener('mouseup', this.endDragHome)
      document.addEventListener('touchmove', this.onDragHome)
      document.addEventListener('touchend', this.endDragHome)
    },
    onDragHome (e) {
      if (!this.isDraggingHome) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartXHome
      const dy = touch.clientY - this.dragStartYHome
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) this.hasMovedHome = true
      const btn = this.$refs.homeBtn
      // 全屏自由移动：上下留 margin 边距（原先无边界可拖出屏幕外找回不回来）
      const margin = 10
      const btnH = 44
      const winH = window.innerHeight
      let newY = this.btnYHome + dy
      if (newY < margin) newY = margin
      if (newY > winH - margin - btnH) newY = winH - margin - btnH
      btn.style.left = (this.btnXHome + dx) + 'px'
      btn.style.top = newY + 'px'
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
    },
    endDragHome () {
      if (!this.isDraggingHome) return
      this.isDraggingHome = false
      document.removeEventListener('mousemove', this.onDragHome)
      document.removeEventListener('mouseup', this.endDragHome)
      document.removeEventListener('touchmove', this.onDragHome)
      document.removeEventListener('touchend', this.endDragHome)
      const btn = this.$refs.homeBtn
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const margin = 10
      const btnW = 44
      const distLeft = rect.left
      const distRight = winW - rect.right
      btn.style.transition = 'all 0.3s ease'
      if (distLeft <= distRight) {
        btn.style.left = margin + 'px'
      } else {
        btn.style.left = (winW - margin - btnW) + 'px'
      }
      setTimeout(() => { btn.style.transition = '' }, 300)
    },
    startDrag (e) {
      // 仅 mouse：阻止原生 drag 会话吞 mousemove。touchstart 上 preventDefault 会吞掉合成 click（手机上按钮点不动）；
      // touch 侧滚动由 CSS touch-action:none 兜底（购物车悬浮钮同款）
      if (e.type === 'mousedown' && e.preventDefault) e.preventDefault()
      this.isDragging = true
      this.hasMoved = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartX = touch.clientX
      this.dragStartY = touch.clientY
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      this.btnX = rect.left
      this.btnY = rect.top
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.endDrag)
    },
    onDrag (e) {
      if (!this.isDragging) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartX
      const dy = touch.clientY - this.dragStartY
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        this.hasMoved = true
      }
      const btn = this.$refs.backBtn
      // 全屏自由移动：上下都留 margin 边距（与 endDrag 吸边 margin 一致），不再限制在上半屏
      const margin = 10
      const btnH = 44
      const winH = window.innerHeight
      let newY = this.btnY + dy
      if (newY < margin) newY = margin
      if (newY > winH - margin - btnH) newY = winH - margin - btnH
      btn.style.left = (this.btnX + dx) + 'px'
      btn.style.top = newY + 'px'
    },
    endDrag () {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.endDrag)
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const margin = 10
      const btnW = 44
      // 只吸附左右两边
      const distLeft = rect.left
      const distRight = winW - rect.right
      btn.style.transition = 'all 0.3s ease'
      if (distLeft <= distRight) {
        btn.style.left = margin + 'px'
      } else {
        btn.style.left = (winW - margin - btnW) + 'px'
      }
      setTimeout(() => {
        btn.style.transition = ''
      }, 300)
    },
    async fetchMoreProducts () {
      // related 后端 /related 按 score DESC 返回（同车型/同规格/同品类）作候选池；
      // 前端排除当前商品后 sampleBySeed 全长洗牌建池，触底分批追加 + 池末换 seed 循环，全程不请求后端。
      if (this.moreProductPool.length > 0) return // 已加载，不重复请求
      const rid = this.$route.query.id
      this.loadingMore = true
      try {
        const res = await this.axios({
          url: `/products/${this.product.id}/related`,
          method: 'get',
          params: { limit: this.moreLimit }
        })
        if (rid !== this.$route.query.id) return
        if (res.data.code === 200) {
          this.moreProductPool = (res.data.data || []).filter(p => p.id !== this.product.id)
          if (this.moreProductPool.length === 0) return
          // 首轮序列 = 强相关头部（后端 _score 降序 → buildStrongHead：有货优先入选/不足补无货，
          // Top8 → 第1位分差保护 + 加权抽3，凑不满 4 自然短头）+ 剩余池 stockFirst 分层洗牌
          // （有货随机段在前、无货段沉底）。同 seed 同序（页面内稳定），重进详情 seed 重生成 →
          // 头部组合变化。第二轮起（池末重洗）走分层纯随机探索，不重复强推。
          this._moreSeed = (Math.random() * 0xffffffff) >>> 0
          const { head, rest } = buildStrongHead(this.moreProductPool, this._moreSeed)
          this._shuffledPool = head.concat(stockFirst(rest, sub => sampleBySeed(sub, this._moreSeed + 2, sub.length)))
          this._round = 0
          this.moreProducts = this._shuffledPool.slice(0, this.BATCH_SIZE).map(p => ({ ...p, _round: 0 }))
          this._poolIndex = this.BATCH_SIZE
          // 首批落 DOM 后点火预载链：首屏/PC 大屏内容不足时连续补 batch，直到 sentinel 退出预载区
          this.$nextTick(() => this.ensurePrefill())
        }
      } catch (err) {
        console.error('加载相关推荐失败:', err)
      } finally {
        this.loadingMore = false
      }
    },
    loadMoreProducts () {
      // 客户端循环：从已缓存的 _shuffledPool 序列分批追加，不请求后端；池末换 seed 重洗（顺序变，非固定重复）
      if (this.loadingMore || this.loading) return
      if (!this.moreProductPool || this.moreProductPool.length === 0) return
      this.loadingMore = true
      setTimeout(() => {
        if (this._poolIndex >= this._shuffledPool.length) {
          this._round = (this._round || 0) + 1
          this._moreSeed = (this._moreSeed + 2654435761) >>> 0 // 黄金比例步进，解耦相邻 seed
          // 分层重洗：有货随机段在前、无货段沉底（第二轮探索同样不让无货顶到前排）
          this._shuffledPool = stockFirst(this.moreProductPool, sub => sampleBySeed(sub, this._moreSeed, sub.length))
          this._poolIndex = 0
        }
        const batch = this._shuffledPool.slice(this._poolIndex, this._poolIndex + this.BATCH_SIZE)
          .map(p => ({ ...p, _round: this._round || 0 })) // 注入轮次，供 :key 区分第二轮起的重复商品
        this.moreProducts = [...this.moreProducts, ...batch]
        this._poolIndex += batch.length
        this.loadingMore = false
        // 批量落 DOM 后复测预载：不足（首屏/PC 大屏/快速滑动）则继续补，sentinel 推出预载区自然停
        this.$nextTick(() => this.ensurePrefill())
      }, 300)
    },
    // 预载判定：sentinel 顶边 < 2.2×vh（视口高 + 1.2×vh 提前量，与 rootMargin 120% 同一数值口径）。
    // loadingMore 即现有互斥锁——一次触发一批；池空由 loadMoreProducts 头部短路断链。
    ensurePrefill () {
      if (this.loadingMore || this.loading) return
      const el = this.$refs.infiniteSentinel
      if (!el) return
      const rect = el.getBoundingClientRect()
      const vh = window.innerHeight || document.documentElement.clientHeight
      if (rect.top < vh * 2.2) this.loadMoreProducts()
    },
    // 瀑布流切换商品：只跳路由，状态重置与重载统一由 watch '$route.query.id' 单路径处理
    // （曾在此处手工复制重载逻辑并提前写 product.id，导致 watch 守卫 newId!==product.id 恒假被短路——评价/点赞状态残留的根因）
    toOtherDetails (productId) {
      this.$router.push({
        path: '/details',
        query: { id: productId }
      })
    },
    categoryText (category) {
      return getCategoryName(category)
    },
    // 分类 Tag 点击 → 规格筛选上下文（类目默认全量；spec_search 通道，后端 WHERE category=key，非文字搜索）
    searchByCategory () {
      if (!this.product.category) return
      this.$router.push({
        path: '/result',
        query: specResultQuery({ category: this.product.category, categoryName: this.categoryDisplayName })
      })
    },
    // 点击车型 → 车型筛选结果页（与筛选页选车型同一条 car_search 通道，非关键词搜索）
    searchByModel (model) {
      if (!model) return
      this.$router.push({
        path: '/result',
        query: { type: 'car', car: JSON.stringify({ name: model }) }
      })
    },
    // 点击枚举规格值 → 规格筛选结果页（spec_search 精确 JSON 匹配，非关键词搜索）；
    // 无类目上下文的纯字段筛选，categoryName 仅作结果页条件展示
    searchBySpec (entry) {
      if (!entry || !entry.key) return
      this.$router.push({
        path: '/result',
        query: { type: 'spec', categoryName: entry.label + ' ' + entry.value, spec: JSON.stringify({ [entry.key]: entry.value }) }
      })
    },
    searchByBrand () {
      if (this.product.brand) {
        this.$router.push({
          path: '/result',
          query: { id: this.product.brand, type: 'keyword' }
        })
      }
    },
    toggleFavorite () {
      this.isFavorited = !this.isFavorited
      // 保存到localStorage
      let favorites = JSON.parse(localStorage.getItem('favorites') || '[]')
      if (this.isFavorited) {
        // 添加收藏
        const item = {
          id: this.product.id,
          name: this.product.name,
          image: this.product.image,
          stock: this.product.stock
        }
        // 检查是否已存在
        const exists = favorites.find(f => f.id === item.id)
        if (!exists) {
          favorites.push(item)
        }
      } else {
        // 取消收藏
        favorites = favorites.filter(f => f.id !== this.product.id)
      }
      localStorage.setItem('favorites', JSON.stringify(favorites))
      this.$q.notify({
        message: this.isFavorited ? '已收藏' : '已取消收藏',
        color: this.isFavorited ? 'positive' : 'grey',
        position: 'top',
        timeout: 1000
      })
    },
    checkFavorite () {
      // 检查当前商品是否已收藏
      const favorites = JSON.parse(localStorage.getItem('favorites') || '[]')
      this.isFavorited = favorites.some(f => f.id === this.product.id)
    },
    async fetchLikeStatus () {
      const rid = this.$route.query.id
      try { const r = await this.axios.get(`/products/${this.product.id}/like`); if (rid !== this.$route.query.id) return; if (r.data.code===200) { this.liked = r.data.data.liked; this.likeCount = r.data.data.like_count } } catch (_) {}
    },
    async toggleLike () {
      try {
        if (this.liked) { const r = await this.axios.delete(`/products/${this.product.id}/like`); if (r.data.code===200) { this.liked = false; this.likeCount = r.data.data.like_count } }
        else { const r = await this.axios.post(`/products/${this.product.id}/like`); if (r.data.code===200) { this.liked = true; if (r.data.data.like_count) this.likeCount = r.data.data.like_count } }
      } catch (_) {}
    },
    btnAdd () {
      if (this.Count < this.maxQuantity) {
        this.Count++
      }
    },
    btnMinus () {
      if (this.Count > 1) {
        this.Count--
      }
    },
    switchUnit (u) {
      if (!u || this.selectedUnitName === u.unit_name) { this.unitMenuOpen = false; return }
      this.unitMenuOpen = false
      const base = this.baseUnitName
      const cur = this.currentUnit.unit_name
      const red = t => `<span style="color:#e53935;font-weight:600">${t}</span>`
      const eq = u.is_base ? '' : `<br>${red(1)} ${u.unit_name} = ${red(u.ratio)} ${base}`
      this.$q.dialog({
        message: `确定要更换单位「${red(cur)}」为「${red(u.unit_name)}」吗？${eq}`,
        html: true,
        ok: { label: '更换', unelevated: true, color: 'primary' },
        cancel: { label: '取消', flat: true }
      }).onOk(() => {
        this.selectedUnitName = u.unit_name
        this.Count = 1
      })
    },
    isNull () {
      if (this.Count <= 0) {
        this.Count = 1
      } else {
        this.Count = Math.min(Math.ceil(this.Count), this.maxQuantity)
      }
    },
    isBlur () {
      if (this.Count <= 0) {
        this.Count = 1
      }
    },
    handleImgError (e) {
      e.target.src = this.defaultImage
    },
    initSwipeBack () {
      // 右滑返回手势：从屏幕右侧边缘向左滑动
      this.touchStartX = 0
      this.touchStartY = 0
      this.touchStartTime = 0

      this.handleTouchStart = (e) => {
        const screenWidth = window.innerWidth
        // 只在屏幕右侧边缘开始触摸（距离右边缘50px内）
        if (e.touches[0].clientX >= screenWidth - 50) {
          this.touchStartX = e.touches[0].clientX
          this.touchStartY = e.touches[0].clientY
          this.touchStartTime = Date.now()
        }
      }

      this.handleTouchMove = (e) => {
        if (this.touchStartX === 0) return

        const touchX = e.touches[0].clientX
        const touchY = e.touches[0].clientY
        const deltaX = this.touchStartX - touchX // 向左滑为正值
        const deltaY = touchY - this.touchStartY

        // 水平滑动距离大于垂直滑动，且向左滑动超过30px
        if (deltaX > 30 && Math.abs(deltaX) > Math.abs(deltaY)) {
          // 可以在这里添加视觉反馈
        }
      }

      this.handleTouchEnd = (e) => {
        if (this.touchStartX === 0) return

        const touchX = e.changedTouches[0].clientX
        const touchY = e.changedTouches[0].clientY
        const deltaX = this.touchStartX - touchX // 向左滑为正值
        const deltaY = touchY - this.touchStartY
        const deltaTime = Date.now() - this.touchStartTime

        // 从右侧边缘向左滑动超过60px，且时间小于400ms，视为返回手势
        if (deltaX > 60 && Math.abs(deltaX) > Math.abs(deltaY) && deltaTime < 400) {
          this.toBack()
        }

        this.touchStartX = 0
        this.touchStartY = 0
      }

      document.addEventListener('touchstart', this.handleTouchStart, { passive: true })
      document.addEventListener('touchmove', this.handleTouchMove, { passive: true })
      document.addEventListener('touchend', this.handleTouchEnd, { passive: true })
    },
    removeSwipeBack () {
      document.removeEventListener('touchstart', this.handleTouchStart)
      document.removeEventListener('touchmove', this.handleTouchMove)
      document.removeEventListener('touchend', this.handleTouchEnd)
    },
    // ===== 库存快捷管理 =====
    stockAdjust (delta) {
      this.stockForm.newStock = Math.max(0, (this.stockForm.newStock || 0) + delta)
    },
    async saveStock () {
      if (this.stockForm.newStock === this.product.stock) {
        this.$toast.fail('库存未变化')
        return
      }
      this.stockSaving = true
      try {
        const res = await this.axios.patch(`/admin/products/${this.product.id}/stock`, {
          stock: this.stockForm.newStock
        })
        if (res.data.code === 200) {
          this.product.stock = this.stockForm.newStock
          this.$toast.success('库存已更新')
          this.showStockDialog = false
        } else {
          this.$toast.fail(res.data.message || '更新失败')
        }
      } catch (err) {
        this.$toast.fail('更新失败')
      } finally {
        this.stockSaving = false
      }
    }
  }
}
